import React, { useReducer, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container, Input, Label } from "reactstrap";
import { initialize, defaultState } from "./store/store";
import style from "./Custody.module.scss";
import { custodyReducer, validateForm } from "./store/reducer";
import Footer from "./Footer";
import { Numeric, Combobox, Field } from "../Order/Field/Field";
import Symbol from "./components/Symbol";
import Account from "../IO/Fields/Account";
import { Mode } from "../../../utils";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { showToast } from "../../../utils/Helper";

const Custody = ({ open, toggle, updateCustodies, services, role, ...props }) => {
  const [state, dispatch] = useReducer(custodyReducer, defaultState(), initialize(props));
  const { fields, custody, ui } = state;
  const { errors, readonly } = fields;
  const [displayMessage, setDisplayMessage] = React.useState(false);

  const [AssetPhysicalDenomination, setAssetPhysicalDenomination] = useState(false);
  const [denominationsUsed, setDenominationsUsed] = useState([]);
  const [denominations, setDenominations] = useState([]);

  const todayDate = new Date().toDateLocal();
  state.custody.internalstatus = "Executed";
  state.custody.externalstatus = "Printed";
  useEffect(() => {
    if (props.retriveAsync && ui.loading) {
      services.fetchGetCustody({ id: custody.id }).then((r) => {
        dispatch({ type: "SET_CUSTODY", custody: r.custody });
      });
    }

    dispatch({ type: "SET_INITIALS_READONLY" });
  }, []);

  const onChange = (fields) => {
    setDisplayMessage(false);
    dispatch({ type: "CHANGE_FIELDS", fields });
    dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
  };

  const precheck = () => {
    state.fields.errors = {};
    state.custody = {
      ...state.custody,
      accountNumber: state.custody.AccountNumber,
      accountName: state.custody.AccountName,
      accountId: state.custody.AccountId,
    };
    dispatch({ type: "CHANGE_MODE", mode: Mode.PRECHECK });
    let hasErrors = validateForm(state);
    if (!hasErrors) {
      let order = {
        OrderQuantityIsCash: "false",
        OrderSide: "Sell",
        AssetId: state.custody.assetid,
        CurrentAccount: {
          AccountId: state.custody.AccountId,
          Quantity: state.custody.volume,
        },
      };
      let custodysdt = {
        ...custody,
        externaldate:
          custody.externaldate === "0000-00-00" || custody.externaldate === ""
            ? custody.date
            : custody.externaldate,
      };
      services.precheck({ custodysdt, order }).then((r) => {
        if (r.validation.result.Code == 200) {
          dispatch({ type: "CHANGE_MODE", mode: Mode.CONFIRM });
        } else {
          showToast(r.validation.result.Description, true);
          dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
        }
      });
    }
  };

  const confirm = () => {
    dispatch({
      type: "CHANGE_FIELDS",
      fields: { assetid: custody.AssetId, accountId: state.custody.AccountId },
    });
    dispatch({ type: "CHANGE_BUTTON_PROPS", props: { confirm: { loading: true } } });
    services
      .fetchUpdateCustody({
        k2btrnmode: "INS",
        custody: {
          ...custody,
          accountId: custody.AccountId,
          assetid: custody.assetid,
          externaldate: custody.externaldate === "0000-00-00" ? custody.date : custody.externaldate,
          denominations: custody.denominationUsed,
        },
      })
      .then((r) => {
        if (r.result.Code === 200) {
          toggle();
          updateCustodies();
          showToast("Ok: custody added with the id: " + r.id, false);
        } else {
          showToast(r.result.Description, true);
          dispatch({ type: "CHANGE_MODE", mode: Mode.EDIT });
        }
      });
  };

  useEffect(() => {
    if (custody) {
      if (custody.assetid) {
        services.fetchGetAssetInformation({ assetId: custody.assetid }).then((response) => {
          setAssetPhysicalDenomination(response.info.AssetPhysicalDenomination);
          onChange({ assetHasDenomination: response.info.AssetPhysicalDenomination });
        });
      }
    }
  }, [custody.assetid]);

  useEffect(() => {
    if (AssetPhysicalDenomination && custody.id) {
      const payload = {
        custodyLockReleaseId: custody.id,
      };
      // getDenominationsByCustody(payload)
      //   .then((response) => {
      //     setDenominationsUsed(response.response.denominations);
      //   })
      //   .catch((err) => console.Error("Error: ", err));
      //setDenominationsUsed(trade.denominationsUsed);
    }
  }, [AssetPhysicalDenomination, custody]);

  useEffect(() => {
    if (AssetPhysicalDenomination && custody.AccountId && custody.assetid) {
      const payload = {
        BasicAccountId: custody.AccountId,
        AssetId: custody.assetid,
        BalanceType: "Current",
        BookType: "Self",
      };
      services.getAvailableDenominationsByAccount(payload).then((response) => {
        setDenominations(response.denominations);
      });
    }
  }, [AssetPhysicalDenomination, custody.AccountId, custody.assetid]);

  const onChangeDenomination = (checked, value, index) => {
    let denominationResult = denominationsUsed;
    if (checked) {
      const denominationAdd = [...denominationsUsed, { key: index, DenominationId: value }];
      setDenominationsUsed(denominationAdd);
      denominationResult = denominationAdd;
    } else {
      const updatedDenomination = denominationsUsed.filter((item) => item.DenominationId !== value);
      setDenominationsUsed(updatedDenomination);
      denominationResult = updatedDenomination;
    }
    onChange({ denominationUsed: denominationResult });
  };

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle}>Custody</ModalHeader>
      <ModalBody className={style.body}>
        <div className={style.form}>
          {ui.loading && <CircularProgress />}
          {!ui.loading && (
            <Container>
              <Row>
                {/* Left */}
                <Col xs={12} lg={6}>
                  {/* Date */}
                  <Field label={"Date"} error={errors.date}>
                    <Input
                      tabIndex="3"
                      type="date"
                      placeholder={"Date"}
                      disabled={true}
                      value={todayDate}
                      invalid={!!errors.date}
                      onChange={(e) => onChange({ date: e.target.value })}
                    />
                  </Field>

                  {/* ##### Volume ###### */}
                  <Field label={"Volume"} error={errors.volume}>
                    <Numeric
                      value={custody.volume}
                      placeholder={"Volume"}
                      onChange={(v) => onChange({ volume: v })}
                      invalid={!!errors.volume}
                      dataTypeDecimalName="currency"
                    />
                  </Field>

                  {/* ##### Symbol ###### */}
                  <Symbol
                    ioType={0}
                    onChange={(v) =>
                      onChange({
                        assetid: v.AssetId,
                        assetticker: v.AssetTicker,
                      })
                    }
                    error={errors.assetticker}
                    value={custody.assetticker}
                    accountId={custody.AccountId}
                    fetchSearchSymbol={services.fetchSearchSymbol}
                  />
                  {
                    <Row>
                      <Col lg={5}>
                        <Field label={"Actual Status"}>
                          <div className={style.box} disabled={false}>
                            {"-"}
                          </div>
                        </Field>
                      </Col>
                      <Col lg={7}>
                        <Field label={"Next Status"} error={errors.type}>
                          <div className={style.box} disabled={false}>
                            {"Executed"}
                          </div>
                        </Field>
                      </Col>
                    </Row>
                  }
                </Col>

                {/* Right */}
                <Col xs={12} lg={6}>
                  {/* ##### Account ###### */}
                  <Account
                    label={"Account"}
                    AccountId={custody.accountid == undefined ? custody.accountid : ""}
                    AccountName={custody.accountname == undefined ? custody.accountname : ""}
                    AccountNumber={custody.accountnumber == undefined ? custody.accountnumber : ""}
                    onChange={(f) => onChange(f)}
                    filter={[]}
                    hideInstruction={true}
                    hideHolder={true}
                    readonly={{
                      AccountNumber: true,
                      AccountName: false,
                    }}
                    errors={{
                      AccountNumber: errors.AccountNumber,
                      AccountName: errors.AccountName,
                    }}
                    services={{
                      fetchSearchAccount: services.fetchSearchAccount,
                    }}
                  />
                  {
                    <React.Fragment>
                      {/* Date */}
                      <Field label={"External Date"} error={errors.externaldate}>
                        <Input
                          tabIndex="3"
                          type="date"
                          placeholder={"Ext. Date"}
                          invalid={!!errors.externaldate}
                          onChange={(e) => onChange({ externaldate: e.target.value })}
                        />
                      </Field>

                      {/* Reference */}
                      <Field label={"Reference"} error={errors.reference}>
                        <Input
                          tabIndex="3"
                          type="text"
                          placeholder={"Reference"}
                          disabled={readonly.reference}
                          invalid={!!errors.reference}
                          onChange={(e) => onChange({ reference: e.target.value })}
                        />
                      </Field>

                      {/* Doc Reference */}
                      <Field label={"Doc. Reference"} error={errors.docreference}>
                        <Input
                          tabIndex="3"
                          type="text"
                          placeholder={"Doc. Reference"}
                          disabled={readonly.docreference}
                          invalid={!!errors.docreference}
                          onChange={(e) => onChange({ docreference: e.target.value })}
                        />
                      </Field>
                    </React.Fragment>
                  }
                </Col>
              </Row>
              <Field>
                {AssetPhysicalDenomination && (
                  <div style={{ width: "100%" }}>
                    <hr />
                    <div style={{ display: "flex" }}>
                      <label
                        style={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          marginLeft: "170px",
                          marginRight: "10px",
                        }}
                      >
                        Denomination
                      </label>
                      <Field noLabel error={errors.denominationUsed}></Field>
                    </div>

                    <hr style={{ border: "1px solid #ccc" }} />
                    {denominations.map((denomination, key) => {
                      const isChecked = denominationsUsed.some(
                        (item) => item.DenominationId === denomination.DenominationId
                      );
                      return (
                        <div key={key}>
                          <Row className="align-items-center mb-3">
                            <Col md="auto">
                              <Input
                                key={key}
                                type="checkbox"
                                checked={isChecked}
                                style={{
                                  position: "relative",
                                  cursor: "pointer",
                                  left: "25px",
                                }}
                                disabled={
                                  denominationsUsed
                                    ? denominationsUsed.some((item) => item.tradeIsAlreadyConfirmed === true)
                                    : false
                                }
                                onChange={(e) => {
                                  onChangeDenomination(e.target.checked, denomination.DenominationId, key);
                                }}
                              />
                            </Col>
                            <Col md="auto">
                              <Label style={{ marginLeft: "140px" }}>{denomination.DenominationTicker}</Label>
                            </Col>
                          </Row>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                )}
              </Field>
            </Container>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Footer
          toggle={toggle}
          dispatch={dispatch}
          buttons={state.buttons}
          actions={{
            precheck,
            confirm,
          }}
        />
      </ModalFooter>
    </Modal>
  );
};

export function validation(custody) {
  return {
    accountNumber: { empty: true },
    accountName: { empty: false },
    volume: { empty: true },
    assetticker: { empty: true, autosuggestId: "assetid" },
  };
}

export default Custody;
